import styled from 'styled-components';
import AppBar from '@material-ui/core/AppBar';
import { RalewayFont } from 'constants/fonts';
import { mediaPhone } from 'styles/utils';

const appHeaderPhone = `
  height: 50px;
  margin-top: 0px;
`;
export const AppHeader = styled(AppBar)`
  && {
    background-color: transparent;
    box-shadow: none;
    height: 45px;
    margin: 0em 22px 0;
    width: calc(100% - 44px);
    transition: background-color 0.4s linear;
    .Navbar--top{
      padding: 3px;
    }

    ${mediaPhone(appHeaderPhone)}
  }  
`;

export const AvatarInitial = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #fff;
  color: #000;
  text-align: center;
  line-height: 50px;
  font-size: 16px; 
`;

export const Breadcrumb = styled.div`
`;

export const BreadcrumbElement = styled.div`
  display: inline-block;
  vertical-align: middle;
  margin-right: 5px;
  color: ${props => props.color};
  font-size: 14px;
  font-family: ${RalewayFont.regularFamily};
  opacity: 0.5;
  
`;

export const SearcherIcon = styled.div`
  display: inline-block;
  vertical-align: middle;
  background-color: #fff;
  margin-right: 10px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  text-align: center;
  padding-top: 11px;
  cursor: pointer;

  i {
    color: ${props => props.color};
    font-size: 14px;
  }
`;

export const UserCardWrapper = styled.div`
  position: absolute;
  width: 98vw;
  height: 98vh;
  top: 1vh;
  z-index: 1500;
  left: 1vw;
  box-shadow: 0px 3px 8px 4px rgba(40, 40, 40, 0.2);
  border-radius: 4px;
  background-color: ${props => props.color};
`;

export const EnvelopeIcon = styled.i`
  color: #fff;
  font-size: 20px;
  position: absolute;
  right: 70px;
  top: 19px;
`;

export const LogoutButton = styled.button`
  border: 1px solid #F44336;
  color: #fff;
  background-color: #F44336;
  position: absolute;
  right: 0px;
  top: 19px;
  font-size: 14px;
  border-radius: 20px;
  padding: 5px 20px;
`;



// WEBPACK FOOTER //
// ./src/components/Navbar/components/styles.js